import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { StandardEcgAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-standard-ecg-slot',
    templateUrl: './standard-ecg-slot.component.html',
    styleUrl: './standard-ecg-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StandardEcgSlotComponent implements SheetSlotComponentBase {

	@Input() action!: StandardEcgAction;
	value = null;

	constructor() {
	}
}